if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', class FooterAccordion extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.footer-block__accordion-content');
      this.isAnimating = false;

      if (!this.details || !this.summary || !this.content) return;

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      
      this.initMedia();
      window.addEventListener('resize', this.onResize.bind(this));
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    initMedia() {
      if (!this.isMobile()) {
        this.details.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', 'true');
      } else {
        this.details.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', 'false');
      }
    }

    onResize() {
      if (!this.isMobile()) {
        this.details.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', 'true');
        this.content.style.height = '';
        this.content.style.opacity = '';
        this.content.style.overflow = '';
        this.content.style.transition = '';
      }
    }

    onSummaryClick(event) {
      if (!this.isMobile()) return;

      event.preventDefault();
      if (this.isAnimating) return;

      if (this.details.hasAttribute('open')) {
        this.close();
      } else {
        this.closeOtherAccordions();
        this.open();
      }
    }

    closeOtherAccordions() {
      const container = this.closest('.footer__blocks-wrapper') || document;
      const otherAccordions = container.querySelectorAll('footer-accordion');
      otherAccordions.forEach((accordion) => {
        if (accordion !== this && accordion.details && accordion.details.hasAttribute('open')) {
          accordion.close();
        }
      });
    }

    open() {
      this.isAnimating = true;
      this.details.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');

      const startHeight = 0;
      const endHeight = this.content.scrollHeight;

      this.content.style.height = `${startHeight}px`;
      this.content.style.opacity = '0';
      this.content.style.overflow = 'hidden';

      // Force reflow
      this.content.offsetHeight;

      this.content.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease';
      this.content.style.height = `${endHeight}px`;
      this.content.style.opacity = '1';

      const onEnd = (e) => {
        if (e.target !== this.content) return;
        this.content.removeEventListener('transitionend', onEnd);
        this.content.style.height = 'auto';
        this.content.style.overflow = 'visible';
        this.content.style.transition = '';
        this.isAnimating = false;
      };

      this.content.addEventListener('transitionend', onEnd);
    }

    close() {
      this.isAnimating = true;
      this.summary.setAttribute('aria-expanded', 'false');

      const startHeight = this.content.scrollHeight;

      this.content.style.height = `${startHeight}px`;
      this.content.style.opacity = '1';
      this.content.style.overflow = 'hidden';

      // Force reflow
      this.content.offsetHeight;

      this.content.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease';
      this.content.style.height = '0px';
      this.content.style.opacity = '0';

      const onEnd = (e) => {
        if (e.target !== this.content) return;
        this.content.removeEventListener('transitionend', onEnd);
        this.details.removeAttribute('open');
        this.content.style.height = '';
        this.content.style.opacity = '';
        this.content.style.overflow = '';
        this.content.style.transition = '';
        this.isAnimating = false;
      };

      this.content.addEventListener('transitionend', onEnd);
    }
  });
}
